module.exports = __webpack_public_path__ + "img/toolbox.a29635ab.svg";